import { CalendarSurfaceStore, createEmptySurfaceStore } from 'owa-calendar-surface-dategrid';
import { DEFAULT_CALENDAR_DATE_RANGE_TYPE } from 'owa-calendar-view-type';
import { createStore } from 'satcheljs';

let surfaceStoreData: CalendarSurfaceStore = createEmptySurfaceStore(
    DEFAULT_CALENDAR_DATE_RANGE_TYPE
);
export const getSurfaceStore = createStore<CalendarSurfaceStore>(
    'calendarSurfaceStore',
    surfaceStoreData
);

const surfaceStore = getSurfaceStore();
export default surfaceStore;
